
"use client";

import { uploadDesign } from "@/server/server-actions";
import { Trash2, Upload } from "lucide-react";
import { useRef, useState, useTransition } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { ImageGenActions, useGeneratedImages } from "@/contexts/GeneratedImagesProvider";
import { ColorType } from "@/utils/APIRouteTypes";


export function ImageUploadItem() {
    const [value, setValue] = useState<null | File>(null);
    const [generatedImages, setGeneratedImages] = useGeneratedImages()
    const [disabled, startTransition] = useTransition()

    const fileInputRef = useRef<HTMLInputElement>(null);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return;
        setValue(e.target.files[0]);
    }

    const handleClear = () => {
        if (fileInputRef.current)
            fileInputRef.current.value = ""

        setValue(null)
    }

    const uploadDesignToServer = async () => {
        if (!value)
            return

        const formData = new FormData()
        formData.append("image", value)

        const response = await uploadDesign(formData)

        setGeneratedImages({ type: ImageGenActions.ADD_IMAGE, payload: [{ src: response.image, color: ColorType.BRIGHT }] })
        setValue(null)
        fileInputRef.current!.value = ""
    }

    const handleUpload = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        if (!value)
            return

        startTransition(uploadDesignToServer)
    }

    return (<>
        <label className="block mb-2 text-sm font-medium text-slate-900 dark:text-white" htmlFor="fileinput">Upload Image to add to design</label>
        <div id="fileUpload" className="flex items-start justify-center">
            <div className="w-full">
                <Input type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleChange}
                    ref={fileInputRef}
                />
            </div>

            <Button onClick={handleUpload} variant={'default'} className="items-center justify-center flex mx-2" disabled={disabled || value === null}><Upload className="h-4 w-4 mr-2" /> Upload</Button>
            <Button onClick={handleClear} variant={'destructive'} className="items-center justify-center flex mx-2" disabled={disabled || value === null} ><Trash2 className="h-4 w-4 mr-2" /> Clear</Button>

        </div>
    </>
    );
}
